import { actualizePrice } from 'sletat-api-services/lib/module/tourActualization/actualizePrice';
import { ActualizePriceRequest } from 'sletat-api-services/lib/module/tourActualization/request';
import { ActualizePriceResponse } from 'sletat-api-services/lib/module/tourActualization/response';

import { hotelPageLogger } from '../../utils/logger';
import { ActualizationStatus, ActualizationData } from '../models/actualization';
import { extractActualizationData } from '../utils/actualization';
import { MODULE_HOST_NAME } from '../../consts/hosts';


export { ActualizePriceRequest, ActualizePriceResponse };

export interface ActualizationInfo {
    status: ActualizationStatus;
    data?: ActualizationData;
}


export function primaryActualization(params: ActualizePriceRequest, tourId: string): Promise<ActualizationInfo> {
    return actualizePrice({ host: MODULE_HOST_NAME })(params)
        .then(resp => {
            if (!!resp.errorMessage) {
                return { status: ActualizationStatus.Failed };
            }
            if (!resp.isFound || !resp.tour) {
                return { status: ActualizationStatus.TourNotFound };
            }
            return {
                status: ActualizationStatus.Success,
                data: extractActualizationData(resp)
            };
        })
        .catch(err => {
            hotelPageLogger.warn(`${tourId} primaryActualization has failed: `, err);
            return { status: ActualizationStatus.Failed };
        });
}
